import { SkeletonBlock } from '../customer-area'

export const QuickActionsSkeleton = () => (
  <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-4">
    {Array.from({ length: 4 }).map((_, index) => (
      <div key={`quick-action-skeleton-${index}`} className="ca-card-shell rounded-xl px-4 py-3">
        <SkeletonBlock className="h-8 w-8 rounded-lg" />
        <SkeletonBlock className="mt-3 h-4 w-28 rounded-md" />
        <SkeletonBlock className="mt-2 h-3 w-full rounded-md" />
        <SkeletonBlock className="mt-1 h-3 w-4/5 rounded-md" />
        <SkeletonBlock className="mt-3 h-3 w-14 rounded-md" />
      </div>
    ))}
  </div>
)

export const KpiSkeleton = () => (
  <section className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
    {Array.from({ length: 4 }).map((_, index) => (
      <div key={`kpi-skeleton-${index}`} className="ca-card-shell rounded-xl px-4 py-3">
        <div className="flex items-start justify-between gap-2">
          <SkeletonBlock className="h-3 w-24 rounded-md" />
          <SkeletonBlock className="h-4 w-4 rounded-md" />
        </div>
        <SkeletonBlock className="mt-3 h-8 w-20 rounded-md" />
        <SkeletonBlock className="mt-3 h-3 w-full rounded-md" />
      </div>
    ))}
  </section>
)

export const RecentOrdersSkeleton = () => (
  <div className="space-y-2">
    {Array.from({ length: 4 }).map((_, index) => (
      <div key={`recent-order-skeleton-${index}`} className="ca-card-shell rounded-xl px-4 py-3.5">
        <div className="flex items-center justify-between gap-3">
          <SkeletonBlock className="h-4 w-36 rounded-md" />
          <SkeletonBlock className="h-6 w-20 rounded-full" />
        </div>
        <SkeletonBlock className="mt-3 h-3 w-40 rounded-md" />
        <SkeletonBlock className="mt-2 h-3 w-28 rounded-md" />
        <div className="mt-3 flex gap-2">
          <SkeletonBlock className="h-8 w-32 rounded-md" />
          <SkeletonBlock className="h-8 w-24 rounded-md" />
        </div>
      </div>
    ))}
  </div>
)

export const TrackingPanelSkeleton = () => (
  <div className="space-y-4">
    <div className="ca-surface-muted rounded-lg px-4 py-4">
      <SkeletonBlock className="h-3 w-28 rounded-md" />
      <SkeletonBlock className="mt-2 h-4 w-36 rounded-md" />
      <SkeletonBlock className="mt-3 h-3 w-full rounded-md" />
      <SkeletonBlock className="mt-1 h-3 w-4/5 rounded-md" />
      <div className="mt-4 grid gap-3 sm:grid-cols-2">
        <SkeletonBlock className="h-10 rounded-md" />
        <SkeletonBlock className="h-10 rounded-md" />
      </div>
    </div>
    <div className="space-y-2">
      {Array.from({ length: 3 }).map((_, index) => (
        <div key={`timeline-skeleton-${index}`} className="flex items-center gap-3">
          <SkeletonBlock className="h-3.5 w-3.5 rounded-full" />
          <SkeletonBlock className="h-3 w-40 rounded-md" />
        </div>
      ))}
    </div>
    <div className="flex gap-2 border-t border-(--color-border-default) pt-4">
      <SkeletonBlock className="h-9 w-36 rounded-md" />
      <SkeletonBlock className="h-9 w-28 rounded-md" />
    </div>
  </div>
)

export const ActivitySkeleton = () => (
  <div className="space-y-2">
    {Array.from({ length: 5 }).map((_, index) => (
      <div key={`activity-skeleton-${index}`} className="ca-surface-muted rounded-lg px-3 py-2.5">
        <SkeletonBlock className="h-3.5 w-40 rounded-md" />
        <SkeletonBlock className="mt-1.5 h-3 w-52 rounded-md" />
      </div>
    ))}
  </div>
)
